export const ALGOLIA_HISTORY = 'ALGOLIA_HISTORY';
export const CHUNK_LOAD_RETRIES = 'CHUNK_LOAD_RETRIES';
